import i18n from '../i18n';

const ERROR_CODE_KEYS = {
  invalid_credentials: 'Login failed. Please check your credentials.',
};

function firstMessage(value) {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    for (const item of value) {
      const message = firstMessage(item);
      if (message) return message;
    }
  }
  if (value && typeof value === 'object') {
    for (const [key, item] of Object.entries(value)) {
      if (key === 'code' || key === 'error_code') continue;
      const message = firstMessage(item);
      if (message) return message;
    }
  }
  return '';
}

/**
 * Convert API errors into UI-language messages.
 *
 * New API errors should expose a stable `code`; legacy English messages are
 * translated when an exact locale entry exists. Unknown server text is never
 * leaked into a non-English UI and falls back to the caller's translated key.
 */
export function getApiErrorMessage(error, t, fallbackKey = 'Something went wrong. Please try again.') {
  const data = error?.response?.data;
  const code = data?.code || data?.error_code;
  const codedKey = ERROR_CODE_KEYS[code];
  if (codedKey) return t(codedKey);

  const rawMessage = firstMessage(data) || (error?.response ? '' : error?.message);
  if (rawMessage) {
    const translated = t(rawMessage);
    const language = i18n.resolvedLanguage || i18n.language || 'en';
    if (language.startsWith('en') || translated !== rawMessage) return translated;
  }

  return t(fallbackKey);
}

